import { Navigate, Outlet } from 'react-router-dom';
import { ApiError } from '../lib/api';
import { useCreatorMe } from '../lib/auth';
import { SplashLoader } from '../components/SplashLoader';

// CreatorBareLayout protects a route with the same auth check as CreatorLayout
// but renders no chrome — no top nav, no tabs, no sign-out. Use it for focused
// flows like first-time onboarding where the hub navigation would just be noise.
export function CreatorBareLayout() {
  const me = useCreatorMe();

  if (me.isPending) return <SplashLoader />;
  if (me.isError) {
    if (me.error instanceof ApiError && me.error.status === 401) {
      return <Navigate to="/creator/login" replace />;
    }
    return <SplashLoader />;
  }
  return <Outlet />;
}
